export default __webpack_public_path__ + "static/popup-desktop-0aa83b9af3ddf85d48af5ecc1de728f2.webp";